<!-- #region Main-body  -->
<div class="main-body">
    <div class="page-wrapper">
        <div class="card" *ngIf="total == 0">
            <div class="card-block panels-wells">
                <div class="row">
                    <div class="col-xl-12 col-lg-4 col-md-4 col-sm-6">
                        <div class="well well-lg text-center" style="font-size: 18px">
                            No cuenta con Operaciones
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-body">
            <!-- #region Both borders table -->
            <div class="card" *ngIf="totalRegistros > 0">
                <div class="card-block">
                    <div class="table-border-style table-font-color table-pad-10">
                        <table class="table table-bordered table-striped table-responsive">
                            <thead>
                                <tr>
                                    <th>
                                        Tipo Reporte
                                    </th>
                                    <th>
                                        Nombre
                                    </th>
                                    <th>
                                        Fecha de Vencimiento Comité
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let bitacora of bitacoraResultados">
                                    <th>
                                        {{ bitacora.tipoReporte }}
                                    </th>
                                    <th>{{ bitacora.nombre}}</th>
                                    <th>{{ bitacora.periodo}}</th>
                                    <td class="text-center">
                                        <span class="mytooltip tooltip-effect-5">
                                            <span class="tooltip-item">
                                                <i 
                                                    class="icofont icofont-document-search" 
                                                    data-toggle="modal"
                                                    data-target="#large-Modal"
                                                    (click)="verDetalle(bitacora)">
                                                </i>
                                            </span>
                                            <span class="tooltip-content clearfix">
                                                <span class="tooltip-text text-center">
                                                    Ver Detalle
                                                </span>
                                            </span>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row table-pad-10">
                    <div class="col">
                        Página {{ carga.Pagina }} de {{numPage}} <br /> 
                        Total {{ totalRegistros }}
                    </div>
                    <div class="col d-flex justify-content-end" *ngIf="totalRegistros > 15">
                        <nav aria-label="Page navigation example">
                            <ul class="pagination justify-content-end">
                                <li class="page-item ">
                                    <button 
                                        class="page-link btn" 
                                        (click)="paginador(false)" 
                                        tabindex="-1"
                                        [disabled]="carga.Pagina <= 1">
                                        Regresar
                                    </button>
                                </li>
                                <li class="page-item">
                                    <button 
                                        class="page-link btn" 
                                        (click)="paginador(true)"
                                        [disabled]="bitacoraResultados === null || total === 0 || 
                                        carga.Pagina == numPage">
                                        Siguiente
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
            <!-- #endregion Both borders table -->
        </div>
    </div>
</div>
<!-- #endregion Main-body  -->
<div class="modal fade" id="large-Modal" tabindex="-1" role="dialog">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">Detalle</h4>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<form>
					<h6 class="text-left text-muted">
						Cliente: {{ monitoreo.nombre }}
					</h6>
                    <div *ngIf="carga.TipoBusqueda == 1">
                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>Tipo de Reporte</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="tipoReporte"
                                        [(ngModel)]="monitoreo.tipoReporte" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Fecha de Vencimiento Comité</label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="periodo"
                                        [(ngModel)]="monitoreo.periodo" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Fecha de Autorización</label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="fechaAutorizacion"
                                        [(ngModel)]="monitoreo.fechaAutorizacion" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>Identificador de Grupo</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="identificadorGrupo"
                                        [(ngModel)]="monitoreo.identificadorGrupo" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Grupo</label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="grupo"
                                        [(ngModel)]="monitoreo.grupo" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Tipo de Cliente</label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="tipoCliente"
                                        [(ngModel)]="monitoreo.tipoCliente" 
                                    />
                                </div>
                            </div>
                        </div>
                        
                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>Tipo de Decisión</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="tipoDecision"
                                        [(ngModel)]="monitoreo.tipoDecision" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Estatus Comité</label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="estatusComite"
                                        [(ngModel)]="monitoreo.estatusComite" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Monto Línea de Crédito Autorizada</label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="montoLineaAutorizada"
                                        [(ngModel)]="monitoreo.montoLineaAutorizada" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Calificación de Riesgo de Crédito del Cliente del CA
                                    </label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="ratingClassCa"
                                        [(ngModel)]="monitoreo.ratingClassCa" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Calificación de Riesgo de Crédito del Cliente Vigente
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="ratingClassVigente"
                                        [(ngModel)]="monitoreo.ratingClassVigente" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>Monto de Cuentas por Pagar</label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="montoCuentasPagar"
                                        [(ngModel)]="monitoreo.montoCuentasPagar" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Disponible</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="disponible"
                                        [(ngModel)]="monitoreo.disponible" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Capacidad de Pago</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="capacidadDePago"
                                        [(ngModel)]="monitoreo.capacidadDePago" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Calificación del Comportamiento de Pago
                                    </label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="paymentBehaviourCa"
                                        [(ngModel)]="monitoreo.paymentBehaviourCa" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Fecha de Prórroga</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="fechaProrroga"
                                        [(ngModel)]="monitoreo.fechaProrroga" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Calificación del Comportamiento de Pago Vigente
                                    </label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="paymentBehaviourVigente"
                                        [(ngModel)]="monitoreo.paymentBehaviourVigente" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Cartera Vencida</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="carteraVencida"
                                        [(ngModel)]="monitoreo.carteraVencida" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Condiciones Comité
                                    </label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="condicionesComite"
                                        [(ngModel)]="monitoreo.condicionesComite" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Observaciones
                                    </label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="observaciones"
                                        [(ngModel)]="monitoreo.observaciones" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Estatus de Línea
                                    </label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="estatusLinea"
                                        [(ngModel)]="monitoreo.estatusLinea" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Extra Línea
                                    </label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="extraLinea"
                                        [(ngModel)]="monitoreo.extraLinea" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Asesor Flotillas
                                    </label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="asesorFlotillas"
                                        [(ngModel)]="monitoreo.asesorFlotillas" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Analist Financiero
                                    </label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="analistaFinanciero"
                                        [(ngModel)]="monitoreo.analistaFinanciero" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Asesor Atención al Cliente
                                    </label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="customerCare"
                                        [(ngModel)]="monitoreo.customerCare" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Tipo de Flotilla
                                    </label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="tipoFlotilla"
                                        [(ngModel)]="monitoreo.tipoFlotilla" 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="carga.TipoBusqueda == 2">
                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>Tipo de Reporte</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="tipoReporte"
                                        [(ngModel)]="monitoreo.tipoReporte" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Fecha de Vencimiento Comité</label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="periodo"
                                        [(ngModel)]="monitoreo.periodo" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Sucursales</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="sucursales"
                                        [(ngModel)]="monitoreo.sucursales" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>Grupo</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="grupo"
                                        [(ngModel)]="monitoreo.grupo" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Identificador de Grupo</label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="identificadorGrupo"
                                        [(ngModel)]="monitoreo.identificadorGrupo" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>Marca</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="marca"
                                        [(ngModel)]="monitoreo.marca" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Nivel de Autorización de la Línea de Crédito
                                    </label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="autorizacionCa"
                                        [(ngModel)]="monitoreo.autorizacionCa" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>Prórroga</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="prorroga"
                                        [(ngModel)]="monitoreo.prorroga" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Días de Prórroga
                                    </label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="diasDeProrroga"
                                        [(ngModel)]="monitoreo.diasDeProrroga" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Estatus Línea Plan Piso
                                    </label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        disabled name="lineaBloqueadaPp"
                                        [(ngModel)]="monitoreo.lineaBloqueadaPp" 
                                    />
                                </div>
                            </div>
                            
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>Deuda Refacciones</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="deudaRefacciones"
                                        [(ngModel)]="monitoreo.deudaRefacciones" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Deuda Otros</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="deudaOtros"
                                        [(ngModel)]="monitoreo.deudaOtros" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Disponibilidad Otros</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="disponibilidadOtros"
                                        [(ngModel)]="monitoreo.disponibilidadOtros" 
                                    />
                                </div>
                            </div>

                            
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>Incremento Temporal</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="incrementoTemporal"
                                        [(ngModel)]="monitoreo.incrementoTemporal" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Total Líneas Autorizadas Crédito
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="lineasAutorizadas"
                                        [(ngModel)]="monitoreo.lineasAutorizadas" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Deuda Crédito
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="deuda"
                                        [(ngModel)]="monitoreo.deuda" 
                                    />
                                </div>
                            </div>
                            
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>Disponibilidad Crédito</label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="disponibilidad"
                                        [(ngModel)]="monitoreo.disponibilidad" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Garantía Total Crédito
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="garantiaTotal"
                                        [(ngModel)]="monitoreo.garantiaTotal" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Unidades Iniciales Nuevas
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="iniciales"
                                        [(ngModel)]="monitoreo.iniciales" 
                                    />
                                </div>
                            </div>
                            
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Unidades Totales Inventario Nuevas
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="totalInventario"
                                        [(ngModel)]="monitoreo.totalInventario" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Unidades > 330 Días Nuevas
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="nuevas330"
                                        [(ngModel)]="monitoreo.nuevas330" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Unidades > 360 Días Nuevas
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="nuevas360"
                                        [(ngModel)]="monitoreo.nuevas360" 
                                    />
                                </div>
                            </div>
                            
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Monto Intereses Vencidos
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="interesesVencidos"
                                        [(ngModel)]="monitoreo.interesesVencidos" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Monto Total Préstamo/Reestructura
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="montoPrestamoReestructura"
                                        [(ngModel)]="monitoreo.montoPrestamoReestructura" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Monto Corporate Non Dealer
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="cnd"
                                        [(ngModel)]="monitoreo.cnd" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Asesor Financiamiento Front Office
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="asesorFo"
                                        [(ngModel)]="monitoreo.asesorFo" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Analista de Líneas
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="analistaDeLineas"
                                        [(ngModel)]="monitoreo.analistaDeLineas" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Analista Financiero
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="analistaFinanciero"
                                        [(ngModel)]="monitoreo.analistaFinanciero" 
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row" >
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Monto Total Flotillas
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="montoTotal"
                                        [(ngModel)]="monitoreo.montoTotal" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Monto Disponible Working Capital
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="disponibilidadWorkingCapital"
                                        [(ngModel)]="monitoreo.disponibilidadWorkingCapital" 
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>
                                        Saldo Auxiliares
                                    </label>
                                    <input 
                                        type="text" class="form-control" 
                                        disabled name="saldoAuxiliares"
                                        [(ngModel)]="monitoreo.saldoAuxiliares" 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
				</form>
			</div>
			<div class="modal-footer">
				<button 
					type="button" 
					class="btn btn-default waves-effect" 
					data-dismiss="modal">
					Regresar
				</button>
			</div>
		</div>
	</div>
</div>